import React from 'react';

/** Marks a pill whose section holds edits that have not been saved yet. */
const UnsavedDot: React.FC = () => (
  <span
    aria-label="unsaved changes"
    style={{ width: 6, height: 6, borderRadius: '50%', background: '#F0B90B', display: 'inline-block' }}
  />
);

export default UnsavedDot;
